import util from '../util'

let controller = 'OperadorFrontEnd'
export default Object.assign({}, util.GetCrud(controller, null), {
    GetAllOperadores: function (dto, options) {
        return util.Axios.GetAll(controller, dto)
    },
    SendEmailRecuperacaoSenha: function (dto) {
        return util.Axios.Post(controller + "/PostEnviaEmailRecuperarSenha", dto)
    },
    GetAcessoUsuario: function (dto, options) {
        if (options && options.data) dto.data = options.data
        return util.Axios.GetAll(controller + "/GetAcessoUsuario", dto)
    },
    AtivarUsuario: function (id) {
        return util.Axios.Post(controller + `/PostAtivarUsuario?id=${id}`, {})
    },
    ComboOperadoresFrontEnd: function (dto) {
        return util.Axios.GetAll(controller + '/ComboOperadoresFrontEnd', dto)
    },
    ListarPorCodigoConta: function (codigoConta) {
        return util.Axios.Get(controller, codigoConta)
    },
    IntegrarUsuarioSSO: function (id) {
        return util.Axios.Post(controller + `/IntegrarUsuarioSSO?id=${id}`, {})
    },
})



